import React, { useState, useEffect } from 'react';
import { object, func, bool, string, array } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import { useLista } from '../../hooks/useLista';
import ContactoModal from '../ContactoModal';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import { TIPS } from '../../../consts/tips';
import { isNull } from '../../../utils/validator';


const ContactosGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      entidad: '',
      idEntidad: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      dataTagger: {
        showModal: false,
        idEntidad: null
      },      
      list: []
  });

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
      const list = props.data.list.filter(x => x.state !== 'r');
      return {...prevState,
        entidad: props.data.entidad,
        idEntidad: props.data.idEntidad,
        list: list };
    });
  }
  useEffect(mount, [props.data]);

  const [, getRowLista] = useLista({
    listas: ['TipoContacto'],
    onLoaded: (listas, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'TipoContacto',
      timeout: 0
    }
  });

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickContactoAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  //los contactos de disabledIds se ven como con la grilla deshabilitada: sin modificar ni eliminar
  const isDisabled = (id) => props.disabled || props.disabledIds.includes(id);

  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickContactoView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!isDisabled(data.value) && (
                                  <div onClick={ (event) => handleClickContactoModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!isDisabled(data.value) && !data.row.original.principal && (
                                  <div onClick={ (event) => handleClickContactoRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickContactosDataTagger(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>                                  
                              </div>

  const getDescTipoContacto = (id) => {
    const row = getRowLista('TipoContacto', id);
    return (row) ? row.nombre : '';
  }

  const tableColumns = [
    { Header: 'Tipo de contacto', Cell: (props) => getDescTipoContacto(props.value), accessor: 'idTipoContacto', width: '30%' },
    { Header: 'Contacto', accessor: 'detalle', width: '60%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickContactoAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        entidad: state.entidad,
        idEntidad: state.idEntidad,
        idTipoContacto: 0,
        detalle: '',
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickContactoView = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickContactoModify = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickContactoRemove = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }

  const handleClickContactosDataTagger = (id) => {
    setState(prevState => {
      return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
    });
  }  

  //funciones
  function RemoveContacto(row) {
    row.state = 'r';
    props.onChange('Contacto', row);
  }

  function UpdateContacto(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('Contacto', row);
  }

  return (
  <>

    {state.dataTagger.showModal &&
      <DataTaggerModalRedux
          title="Información adicional de contacto"
          processKey={props.processKey}
          entidad="Contacto"
          idEntidad={state.dataTagger.idEntidad}
          disabled={isDisabled(state.dataTagger.idEntidad)}
          tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_CONTACTO_MODAL}
          onDismiss={() => {
            setState(prevState => {
              return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
            });
          }}
      />
    }

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveContacto(row);
            }}
        />
    }

    {state.showForm && 
        <ContactoModal
            processKey={props.processKey}
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateContacto(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

  </>
  );
}

ContactosGrid.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  disabledIds: array,
  data: object.isRequired,
  onChange: func.isRequired
};

ContactosGrid.defaultProps = {
  disabled: false,
  disabledIds: []
};

export default ContactosGrid;